module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71016/img/blog-post-zero.png"